export const selector = 'dbAFormSubmit';

/* @ngInject */
export default function FormSubmitDirective($q) {
    return {
        require: '^form',
        restrict: 'A',

        link(scope, element, attrs, ctrl) {
            let watcher = null;
            ctrl.$submitting = false;

            scope.$watch(serialize, changeHandler);

            element.on('submit', submitHandler);
            scope.$on('$destroy', () => element.off('submit', submitHandler));

            function submitHandler() {
                if (ctrl.$valid) {
                    updateState(true);

                    $q.when(scope.callback()).finally(() => updateState(false));
                } else {
                    validate();
                }
            }

            function validate() {
                scope.$applyAsync(makeControlsDirty);

                if (watcher) {
                    watcher();
                }

                watcher = scope.$watch(serialize, (newValue, oldValue) => {
                    if (newValue !== oldValue) {
                        watcher();
                        ctrl.$setPristine();
                        ctrl.$setUntouched();
                        makeControlsDirty();
                    }
                });
            }

            function makeControlsDirty() {
                ctrl.$$controls.forEach((control) => control.$setDirty());
            }

            function updateState(submitting) {
                scope.$applyAsync(() => ctrl.$submitting = submitting);
            }

            function serialize() {
                return JSON.stringify(ctrl.$$controls.map((control) => control.$viewValue));
            }

            function changeHandler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    scope.onChange();
                }
            }
        },

        scope: {
            callback: `&${selector}`,
            onChange: '&'
        }
    };
}



// WEBPACK FOOTER //
// ./src/application/directive/form-submit/form-submit.directive.js